import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import './Navigation.css';

const Navigation: React.FC = () => {
  const location = useLocation();
  const isTestPage = location.pathname === '/football-iq-test';

  // Don't show navigation on the Football IQ Test page (neutral page)
  if (isTestPage) {
    return null;
  }

  return (
    <nav className="navigation">
      <div className="nav-container">
        {/* Desktop logo */}
        <Link to="/" className="nav-logo nav-logo-desktop">
          <img src="/images/logo-clean.png" alt="Xcelerate" />
        </Link>
        
        {/* Mobile full logo */}
        <Link to="/" className="nav-logo nav-logo-mobile">
          <img src="/images/logo-full-mobile.png" alt="Xcelerate" />
        </Link>
        
        <ul className="nav-menu">
          <li><Link to="/" className={location.pathname === '/' ? 'active' : ''}>Home</Link></li>
          <li><Link to="/about" className={location.pathname === '/about' ? 'active' : ''}>About</Link></li>
          <li><Link to="/services" className={location.pathname === '/services' ? 'active' : ''}>Services</Link></li>
          <li><Link to="/scholarship" className={location.pathname === '/scholarship' ? 'active' : ''}>Scholarship</Link></li>
          <li><Link to="/waiver" className={location.pathname === '/waiver' ? 'active' : ''}>Waiver</Link></li>
          <li><Link to="/contact" className={location.pathname === '/contact' ? 'active' : ''}>Contact</Link></li>
        </ul>
      </div>
    </nav>
  );
};

export default Navigation;

